module.exports = __webpack_public_path__ + "img/road_curve.aff33cab.svg";